export const ENV = {
  SOCKET_URL: "https://wsamco.sitesas.com",
  GOOGLE_MAP_KEY: ""
};
